import { schedulePowerApi } from "@/features/powerRootSlice/services/powerApi";
import type { RootState } from "@/store";
import { dynamicSlicesNames } from "@/store.constants";
import { scheduleExchangeSliceName } from "../../powerSlice";
import { initialState } from "./websocketConfig";

export const websocketQuery = (state: RootState) => {
  return (
    schedulePowerApi.endpoints.getWebsocketMessages.select(
      state?.[dynamicSlicesNames.POWER]?.[scheduleExchangeSliceName]
        ?.selectedResource ?? ""
    )(
      state as RootState & {
        schedulePowerApi: typeof schedulePowerApi.reducerPath;
      }
    )?.data ?? initialState
  );
};
